import { fetchAuthSession } from "aws-amplify/auth";
import { get } from "aws-amplify/api";
import { useQuery } from "react-query";
import { useUserMutation } from "../../common/useUserMutation";

export const PROFILE_DATA_QUERY_KEY = "PROFILE_DATA_QUERY_KEY";

export const useProfileQuery = (patientUserId) => {
  const userMutation = useUserMutation();
  return useQuery({
    queryKey: [PROFILE_DATA_QUERY_KEY, patientUserId],
    retry: false,
    queryFn: async () => {
      const session = await fetchAuthSession();
      const { body } = await get({
        apiName: "pcmedapi",
        path: "/profile/about/" + patientUserId,
        options: {
          headers: {
            Authorization: session.tokens.idToken.toString(),
          },
        },
      }).response;
      return await body.json();
    },
    enabled: !!patientUserId,
    select: (profile) => {
      const pPhone = profile?.primaryPhone?.split("-") ?? null;
      return {
        ...profile,
        primaryPhone: pPhone ? pPhone[1] : "",
        primaryDialCode: pPhone ? pPhone[0] : "",
      };
    },
    onSuccess: (data) => {
      let advocateSessionValues = JSON.parse(
        sessionStorage.getItem("advocateSession")
      );
      if (
        advocateSessionValues &&
        advocateSessionValues?.isAdvocating &&
        advocateSessionValues?.patientUserId === data?.patientUserId
      ) {
        advocateSessionValues.givenName = data?.givenName;
        advocateSessionValues.nickname = data?.nickname;
        sessionStorage.setItem(
          "advocateSession",
          JSON.stringify(advocateSessionValues)
        );
        userMutation.mutate(advocateSessionValues);
      }
    },
  });
};

export const useProfileGetByEmailQuery = (email) => {
  return useQuery({
    queryKey: [PROFILE_DATA_QUERY_KEY, email],
    retry: false,
    queryFn: async () => {
      const session = await fetchAuthSession();
      const { body } = await get({
        apiName: "pcmedapi",
        path: "/profile/about/search/email",
        options: {
          headers: {
            Authorization: session.tokens.idToken.toString(),
          },
          queryParams: {
            email: email,
          },
        },
      }).response;
      return await body.json();
    },
  });
};

export const useProfileGetByUsernameQuery = (username) => {
  return useQuery({
    queryKey: [PROFILE_DATA_QUERY_KEY, username],
    retry: false,
    queryFn: async () => {
      const session = await fetchAuthSession();
      const { body } = await get({
        apiName: "pcmedapi",
        path: "/profile/about/search/username",
        options: {
          headers: {
            Authorization: session.tokens.idToken.toString(),
          },
          queryParams: {
            username: username,
          },
        },
      }).response;
      return await body.json();
    },
  });
};
